import { Key } from 'react'
import { FlatListProps, ItemWithId } from './types'

type UseListKeyGeneratorHook<Item extends ItemWithId> = (item: Item, index: number) => Key

export default function useListKeyGenerator<Item extends ItemWithId>(
    keyExtractor?: FlatListProps<Item>['keyExtractor']
): UseListKeyGeneratorHook<Item> {
    return (item, index) => {
        if (keyExtractor) {
            return keyExtractor(item, index)
        }

        return String(item.id ?? index)
    }
}
